import React from "react";
import { inject, observer } from "mobx-react";
import { BestDropdown, FilterHeader, FormColumn4Wide, PrimaryButton } from "best-common-react";
import LoadingSpinner from "../../loading/LoadingSpinner";

class VenueEditFilters extends React.Component {
  render() {
    const { venueEditStore } = this.props.rootStore;

    function handleFileChange(e) {
      if (e.target.files) {
        venueEditStore.setUploadingFile(e.target.files[0]);
      }
    }

    return (
      <>
        <LoadingSpinner />
        <div className="row">
          <FormColumn4Wide>
            <div className="form-group">
              <BestDropdown
                id="season"
                title="Season"
                value={venueEditStore.getSelectedSeason}
                options={venueEditStore.availableSeasons}
                onChange={venueEditStore.setSelectedSeason}
              />
            </div>
          </FormColumn4Wide>
          <FormColumn4Wide>
            <div className="form-group">
              <FilterHeader>Location</FilterHeader>
              <div id="venue-location">{venueEditStore.currentVenueLocation}</div>
            </div>
          </FormColumn4Wide>
          <FormColumn4Wide>
            <div className="form-group">
              <FilterHeader>Seatmap</FilterHeader>
              <p style={{ fontSize: "10px" }}>
                Please note: Uploading a seat map will apply this image to all seasons for this venue. Please use a .PNG
                file.
              </p>
              <img
                alt={(venueEditStore.currentVenue?.name || "no") + " seat map"}
                src={venueEditStore.currentVenue?.venueSeatmapUrl}
                width="150"
                height="150"
              />
            </div>
          </FormColumn4Wide>
          <FormColumn4Wide>
            <div className="form-group">
              <div className="d-row">
                <input type="file" accept="image/png" onChange={handleFileChange} />
              </div>
              <div className="d-row mt-2">
                <PrimaryButton
                  disabled={venueEditStore.uploadingFile === null}
                  onClick={() => venueEditStore.updateSeatmap()}
                >
                  Upload
                </PrimaryButton>
              </div>
              <div className="d-row mt-2">
                <PrimaryButton
                  disabled={
                    venueEditStore.currentVenue?.venueSeatmapUrl == null ||
                    venueEditStore.currentVenue?.venueSeatmapUrl === ""
                  }
                  onClick={() => venueEditStore.removeSeatmap(venueEditStore.currentVenue)}
                >
                  Remove Seatmap
                </PrimaryButton>
              </div>
            </div>
          </FormColumn4Wide>
        </div>
      </>
    );
  }
}

export default inject("rootStore")(observer(VenueEditFilters));
